/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_ZH_HK: Record<string, string> = {
    ariaAnnounceChart: '圖表，${seriesCount}[number] 系列',
    ariaAnnounceFlowProportionLink: '連結 ${index} 的 ${count}，從 ${from} 到 ${to}，${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: '節點 ${index} 在 ${count} 中, ${description}',
    ariaAnnounceGaugeChart: '儀表圖, ${caption}',
    ariaAnnounceHierarchyChart: '層次圖, ${caption}',
    ariaAnnounceHierarchyDatum: '層級 ${level}[number]，${count}[number] 個子項，${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: '按空格或 Enter 鍵切換可見性',
    ariaLabelAddHorizontalLine: '添加水平線',
    ariaLabelAnnotationOptionsToolbar: '註解選項',
    ariaLabelAnnotationSettingsDialog: '註釋設置',
    ariaLabelColorPicker: '顏色選擇器',
    ariaLabelFinancialCharts: '財務圖表',
    ariaLabelLegend: '圖例',
    ariaLabelLegendItem: '${label}, 圖例項目第 ${index}[number] / ${count}[number]',
    ariaLabelLegendItemUnknown: '未知的圖例項目',
    ariaLabelLegendPageNext: '下一頁圖例',
    ariaLabelLegendPagePrevious: '上一頁圖例',
    ariaLabelLegendPagination: '圖例分頁',
    ariaLabelNavigator: '導航器',
    ariaLabelNavigatorMaximum: '最大',
    ariaLabelNavigatorMinimum: '最小值',
    ariaLabelNavigatorRange: '範圍',
    ariaLabelRangesToolbar: '範圍',
    ariaLabelSettingsTabBar: '設定',
    ariaLabelZoomToolbar: '縮放',
    ariaValuePanRange: '${min}[percent0to2dp] 至 ${max}[percent0to2dp]',
    contextMenuDownload: '下載',
    contextMenuPanToCursor: '平移到這裡',
    contextMenuToggleOtherSeries: '切換其他系列',
    contextMenuToggleSeriesVisibility: '切換顯示',
    contextMenuZoomToCursor: '放大至此處',
    dialogHeaderChannel: '頻道',
    dialogHeaderDatePriceRange: '日期及價格',
    dialogHeaderDateRange: '日期範圍',
    dialogHeaderFibonacciRange: '斐波那契回撤',
    dialogHeaderLine: '線',
    dialogHeaderPriceRange: '價格範圍',
    dialogHeaderText: '文字',
    dialogInputAlign: '對齊',
    dialogInputColorPicker: '顏色',
    dialogInputColorPickerAltText: '文字顏色',
    dialogInputExtendAbove: '擴展至上方',
    dialogInputExtendBelow: '向下延展',
    dialogInputExtendChannelEnd: '擴展通道結束',
    dialogInputExtendChannelStart: '延長通道起點',
    dialogInputExtendLeft: '向左扩展',
    dialogInputExtendLineEnd: '延長線末端',
    dialogInputExtendLineStart: '延長線的起點',
    dialogInputExtendRight: '向右延伸',
    dialogInputFibonacciBands: '波段',
    dialogInputFibonacciBandsAltText: '斐波那契波段',
    dialogInputFillColorPicker: '填滿',
    dialogInputFillColorPickerAltText: '填充顏色',
    dialogInputFontSize: '大小',
    dialogInputFontSizeAltText: '字型大小',
    dialogInputLineStyle: '虛線',
    dialogInputPosition: '位置',
    dialogInputReverse: '反轉',
    dialogInputShowFill: '顯示填充',
    dialogInputStrokeWidth: '線寬',
    dialogInputStrokeWidthAltText: '線條粗細',
    iconAltTextAlignCenter: '「置中」',
    iconAltTextAlignLeft: '左',
    iconAltTextAlignRight: '右',
    iconAltTextClose: '關閉',
    iconAltTextLineStyleDashed: '長虛線',
    iconAltTextLineStyleDotted: '短虛線',
    iconAltTextLineStyleSolid: '實線',
    iconAltTextPositionBottom: '下方',
    iconAltTextPositionCenter: '中間',
    iconAltTextPositionTop: '頂部',
    inputTextareaPlaceholder: '添加文字',
    measurerDateRangeBars: '${value}[number] 條',
    measurerPriceRangePercent: '${value}[percent]香港',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: '體積 ${value}',
    overlayLoadingData: '正在載入數據...',
    overlayNoData: '沒有資料展示',
    overlayNoVisibleSeries: '沒有可見的系列',
    overlayUnsupportedBrowser: '瀏覽器版本不兼容。 請升級您的瀏覽器。',
    seriesHistogramTooltipCount: '${yName}（計數）',
    seriesHistogramTooltipFrequency: '頻率',
    seriesHistogramTooltipMean: '${yName}（平均）',
    seriesHistogramTooltipSum: '${yName}（總和）',
    toolbarAnnotationsArrow: '箭咀',
    toolbarAnnotationsArrowDown: '向下箭頭',
    toolbarAnnotationsArrowUp: '上箭頭',
    toolbarAnnotationsCallout: '標注',
    toolbarAnnotationsClearAll: '清除全部',
    toolbarAnnotationsComment: '評論',
    toolbarAnnotationsDatePriceRange: '日期和價格',
    toolbarAnnotationsDateRange: '日期範圍',
    toolbarAnnotationsDelete: '刪除',
    toolbarAnnotationsDisjointChannel: '獨立頻道',
    toolbarAnnotationsDragHandle: '拖動工具欄',
    toolbarAnnotationsFibonacciAnnotations: '斐波那契',
    toolbarAnnotationsFibonacciRetracement: '斐波那契回撤',
    toolbarAnnotationsFibonacciRetracementTrendBased: '斐波那契趨勢基於',
    toolbarAnnotationsFillColor: '填充顏色',
    toolbarAnnotationsHorizontalLine: '水平線',
    toolbarAnnotationsLineAnnotations: '趨勢線',
    toolbarAnnotationsLineColor: '線條顏色',
    toolbarAnnotationsLineStrokeWidth: '線條寬度',
    toolbarAnnotationsLineStyle: '線條樣式',
    toolbarAnnotationsLock: '鎖定',
    toolbarAnnotationsMeasurerAnnotations: '測量工具',
    toolbarAnnotationsNote: '註釋',
    toolbarAnnotationsParallelChannel: '平行通道',
    toolbarAnnotationsPriceRange: '價格範圍',
    toolbarAnnotationsQuickDatePriceRange: '測量',
    toolbarAnnotationsSettings: '設置',
    toolbarAnnotationsShapeAnnotations: '箭咀',
    toolbarAnnotationsText: '文字',
    toolbarAnnotationsTextAnnotations: '文字標註',
    toolbarAnnotationsTextColor: '文字顏色',
    toolbarAnnotationsTextSize: '文字大小',
    toolbarAnnotationsTrendLine: '趨勢線',
    toolbarAnnotationsUnlock: '解鎖',
    toolbarAnnotationsVerticalLine: '垂直線',
    toolbarRange1Month: '1個月',
    toolbarRange1MonthAria: '1個月',
    toolbarRange1Year: '1年',
    toolbarRange1YearAria: '1年',
    toolbarRange3Months: '3個月',
    toolbarRange3MonthsAria: '3 個月',
    toolbarRange6Months: '6個月',
    toolbarRange6MonthsAria: '6個月',
    toolbarRangeAll: '全部',
    toolbarRangeAllAria: '全部',
    toolbarRangeYearToDate: '年初至今',
    toolbarRangeYearToDateAria: '年初至今',
    toolbarSeriesTypeCandles: '蠟燭',
    toolbarSeriesTypeDropdown: '圖表種類',
    toolbarSeriesTypeHighLow: '高低',
    toolbarSeriesTypeHLC: '高低收',
    toolbarSeriesTypeHollowCandles: '空心蠟燭',
    toolbarSeriesTypeLine: '線圖',
    toolbarSeriesTypeLineWithMarkers: '帶標記的折線圖',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: '階梯線',
    toolbarZoomPanEnd: '平移至結尾',
    toolbarZoomPanLeft: '向左平移',
    toolbarZoomPanRight: '向右平移',
    toolbarZoomPanStart: '移到起點',
    toolbarZoomReset: '重設縮放',
    toolbarZoomZoomIn: '放大',
    toolbarZoomZoomOut: '縮小',
    tooltipPaginationStatus: '${index}[number] 的 ${count}[number]',
};
